import { mirrorEasing } from './basler-components.es828.js';
import { reverseEasing } from './basler-components.es829.js';

const circIn = (p) => 1 - Math.sin(Math.acos(p));
const circOut = reverseEasing(circIn);
const circInOut = mirrorEasing(circIn);

export { circIn, circInOut, circOut };
